export const SearchResultsTypes = {
  billsOfLading: "BOL",
  carrier: "CAR",
  invoice: "INV",
  purchaseOrder: "PO",
  shipTo: "CS",
  soldTo: "B",
  vehicle: "VEH",
  millOrder: "MO"
};



// WEBPACK FOOTER //
// ./src/components/AdvancedSearch/SearchResults/SearchResultsTypes.js